import React, { useState } from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import { imageUrl } from "gatsby-plugin-sanity-image"
import BlockHeader from "components/BlockHeader"
import VideoModal from "components/VideoModal"
import theme from "styles/theme"

const VideoBlock = ({ label, title, background, video }) => {
  const [open, setOpen] = useState(false)
  const bg = {
    desktop: imageUrl(background, { width: 1440, height: 440 }),
    mobile: imageUrl(background, { width: 375, height: 320 }),
  }

  return (
    <div
      css={{
        background: theme.midBlue,
        backgroundImage: `url(${bg.desktop})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        color: theme.lightYellow,
        textAlign: "center",
        padding: "140px 24px",
        "--modalPadding": "36px",
        [theme.mobile]: {
          backgroundImage: `url(${bg.mobile})`,
          "--modalPadding": "24px",
        },
      }}
    >
      <BlockHeader
        label={label}
        title={title}
        css={{
          "--labelColor": theme.lightYellow,
          "--titleColor": theme.white,
        }}
      />
      <PlayButton
        onClick={() => {
          setOpen(true)
        }}
        css={{
          width: 52,
          margin: "24px auto 0",
          cursor: "pointer",
          transition: "color 250ms",
          "&:hover": { color: theme.midOrange },
          [theme.mobile]: {
            width: 42,
          },
        }}
      />

      <VideoModal
        open={open}
        url={video}
        onRequestClose={() => {
          setOpen(false)
        }}
      />
    </div>
  )
}

export default VideoBlock

VideoBlock.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  video: PropTypes.string.isRequired,
  background: PropTypes.shape({
    asset: PropTypes.object.isRequired,
  }).isRequired,
}

const PlayButton = props => (
  <svg fill="none" viewBox="0 0 52 52" {...props}>
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M26 51a25 25 0 100-50 25 25 0 000 50zm-2.4-33.8L22 16v19l1.6-1.2 10-7.5 1-.8-1-.8-10-7.5z"
    />
  </svg>
)

export const query = graphql`
  fragment VideoBlock on SanityVideoBlock {
    label
    title
    video
    background {
      ...Image
    }
  }
`
